import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "currentColor",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("g", null, [
        _createElementVNode("g", null, [
          _createElementVNode("path", {
            d: "M18.46 6.48c.286-.298.76-.308 1.06-.02.271.26.304.676.092.974l-.071.086-9.608 10c-.276.287-.722.305-1.02.058l-.077-.074-4.392-4.849c-.278-.307-.255-.781.052-1.06.28-.252.697-.256.98-.024l.08.077 3.852 4.253 9.051-9.42z",
            transform: "translate(-524 -369) translate(524 369)"
          })
        ])
      ])
    ], -1)
  ]))]))
}
export default { render: render }